export const containsRequiredError = (e: any, errorType: any): boolean => {
	if (e?.error?.errors && Array.isArray(e.error.errors)) {
		const result = e.error.errors.filter((elem) => elem.reason === errorType);
		return !!result.length;
	}

	return false;
};
